import { useEffect } from "react";

import { brandMarkPath } from "../../../components/common/BrandLockup";
import type { ShellState } from "../domain/shellTypes";

export function AuthenticatedAppGate({ state }: { state: ShellState }) {
  useEffect(() => {
    if (state.status !== "unauthenticated" || typeof window === "undefined") {
      return;
    }

    const loginPath = window.location.pathname.startsWith("/go/") ? "/go/login" : "/login";
    window.location.replace(loginPath);
  }, [state.status]);

  const isError = state.status === "error";
  const isUnauthenticated = state.status === "unauthenticated";

  return (
    <main className="authgate" aria-label="Acesso ao THH GO">
      <section className="authgate__panel">
        <div className="authgate__brand" aria-label="THH GO">
          <img className="authgate__brandMark" src={brandMarkPath} alt="" aria-hidden="true" />
          <strong>THH GO</strong>
        </div>
        <div className="authgate__copy">
          <h1>{isUnauthenticated ? "Entre para continuar" : isError ? "Falha no boot" : "Validando sessão"}</h1>
          <p>
            {isUnauthenticated
              ? "Sua sessão não está ativa. Vamos levar você para o login seguro."
              : isError
                ? state.message
                : "Estamos verificando sua sessão antes de abrir a área logada."}
          </p>
        </div>
        <a className="authgate__action" href="/go/login">Ir para login</a>
      </section>
    </main>
  );
}
